import React from "react";
import Context from "../../../Context";
import TemplatesListRow from "./TemplatesListRow";
import List from "../../Misc/List";
import FieldsList from "../../Misc/FieldsList";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import { Link } from "react-router-dom";
import { essenceClass } from "../../../essense";
import TemplatesListGrid from "./TemplatesListGrid";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Blocker from "../../Misc/Blocker";
import visualState from "../../../visualState";

let searchTimeout = null;

export default class TemplatesList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "templateListFields";
  constructor(props) {
    super(props);

    this.vState = new visualState("ManualTemplateList");

    this.state = {
      pending: false,
      searchPending: false,
      search: [],
      customListKey: "",
      viewGrid: this.vState.read("viewGrid", true),
      filters: {
        show: false,
        active: [],
        default: [],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      fields: {
        grid: [
          "id",
          "label",
          "structure",
          "statetypecode",
          "statelabel",
          "classlabel",
          "classcode",
          "rendered",
        ],
        rows: [
          "id",
          "label",
          "structure",
          "statetypecode",
          "statelabel",
          "classlabel",
          "classcode",
        ],
      },
      sortings: {
        all: [
          {
            id: "byLabelAsc",
            active: true,
            title: "По алфавиту",
            value: ["label ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: ["label ASC"],
      },
    };
  }
  componentDidMount() {
    this.loadInfo();
    this.setDefaultFilters();
  }

  setDefaultFilters = () => {
    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];
      filters.default.push({
        lstr: "(",
        field: "structure",
        compare: "EQL",
        value: this.props.structure,
        rstr: ")",
      });
      filters.default.push({
        lstr: "(",
        field: "classcode",
        compare: "NEQ",
        value: "workdoc",
        rstr: ")",
      });
      return filters;
    });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.structure !== this.props.structure) {
      this.setDefaultFilters();
    }
  }

  loadInfo = async () => {
    let essence = new essenceClass("manual");

    let stateList = await essence.getStateList();
    if (Array.isArray(stateList)) {
      let variants = [];
      stateList.forEach((item) =>
        variants.push([
          item.label,
          [{ field: "statecode", compare: "EQL", value: item.code }],
        ])
      );
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "statecode",
          title: "По статусу",
          kind: "dropdown",
          multiple: true,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }

    let typeList = await essence.getTypeList();
    if (Array.isArray(typeList)) {
      let variants = [];
      typeList.forEach((item) =>
        variants.push([
          item.name,
          [{ field: "typecode", compare: "EQL", value: item.code }],
        ])
      );
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "typecode",
          title: "По типу",
          kind: "dropdown",
          multiple: true,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }
  };

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleView = () => {
    this.setState(
      (state) => {
        let viewGrid = !state.viewGrid;
        this.vState.save({ viewGrid });
        return { viewGrid };
      },
      () => {
        if (this.props.onChangeView)
          this.props.onChangeView(this.state.viewGrid);
      }
    );
  };
  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (searchValue) => {
    this.setState({ searchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let search = searchValue
        ? [
            {
              lstr: "(",
              field: "label",
              compare: "IKE",
              value: `%${searchValue}%`,
              rstr: ")",
            },
          ]
        : [];
      this.setState({ searchPending: false, search });
    }, 1500);
  };

  onFinish = () => {
    this.setState({ customListKey: this.context.key() });
  };

  onListLoadStart = () => {
    this.setState({ pending: true });
  };
  onListLoadEnd = () => {
    this.setState({ pending: false });
  };

  render() {
    let filters = (
      <div
        className={`${
          this.state.filters.show ? "d-flex" : "d-none"
        }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
      >
        <Filters
          key={JSON.stringify(this.state.filters.all)}
          changeFn={this.handleFilters}
          filters={this.state.filters.all}
        />
      </div>
    );

    return (
      <>
        {this.props.foldersComponent}

        <div className="card card-custom  ">
          <div className="card-header px-5 py-2">
            <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
              <div className="text-nowrap d-inline-block mr-2">
                {this.state.searchPending ? (
                  <div className="spinner mr-10 d-inline-block"></div>
                ) : (
                  ""
                )}
                <input
                  className="form-control form-control-solid d-inline-block w-auto"
                  type="text"
                  placeholder="Поиск"
                  onChange={(e) => this.handleSearch(e.target.value)}
                />
              </div>

              <div>
                {false ? (
                  <FieldsList
                    changeFn={this.handleFields}
                    fields={this.state.fields.all}
                    activeFields={this.state.fields.active}
                  />
                ) : null}

                <button
                  className="btn btn-light mr-2"
                  onClick={() => this.toggleFilters(!this.state.filters.show)}
                >
                  <i
                    className={`fa fa-filter p-0 ${
                      this.state.filters.show ? "text-primary" : "text-muted"
                    }`}
                  ></i>
                </button>
                <Sortings
                  changeFn={this.handleSortings}
                  sortings={this.state.sortings.all}
                />
                <button
                  onClick={this.handleView}
                  className="btn btn-icon btn-light  ml-2 text-hover-primary"
                >
                  <i
                    className={`fa ${
                      !this.state.viewGrid ? "fa-th" : "fa-th-list"
                    } p-0 align-middle text-muted`}
                  ></i>
                </button>
              </div>
            </div>
          </div>
          {filters}
          <div className="card-body px-5">
            {this.state.filters.default.length && (
              <List
                listKey="TemplatesList"
                key={this.state.customListKey}
                fulltext={JSON.stringify(this.state.search)}
                search={JSON.stringify(
                  this.state.filters.active.concat(this.state.filters.default)
                )}
                sort={JSON.stringify(this.state.sortings.active)}
                fields={JSON.stringify(
                  this.state.viewGrid
                    ? this.state.fields.grid
                    : this.state.fields.rows
                )}
                limit={20}
                keyField="id"
                path="/manual/list"
                row={this.state.viewGrid}
                onLoadStart={this.onListLoadStart}
                onLoadEnd={this.onListLoadEnd}
                multiselect={this.state.viewGrid ? false : true}
              >
                {this.state.viewGrid ? (
                  <TemplatesListGrid
                    structure={this.props.structure}
                    wide={this.props.wide}
                    onDrop={this.onFinish}
                  />
                ) : (
                  <TemplatesListRow
                    structure={this.props.structure}
                    onDrop={this.onFinish}
                  />
                )}
              </List>
            )}
          </div>
        </div>
      </>
    );
  }
}
